import { reqOptions } from "../../utils";

const useAPI = () => {
	const handleGetService = async (API, state, type) => {
		switch (type) {
			case "listgroup":
				API += `&idlayanan=${state.idlayanan}&idgroup=${state.idgroup}`;
				break;
			case "userrole":
				API += `&idlayanan=${state.idlayanan}&idrole=${state.idrole}`;
				break;
			case "tasks":
				API += `&idlayanan=${state.idlayanan}&idkategori=${state.idkategori}&idstatus=${state.idstatus}`;
				break;
			case "listLog":
				API += `&tanggal=${state.tanggal}&iduser=${state.iduser}`;
				break;
			case "listReport":
				API += `&tgl_awal=${state.tgl_awal}&tgl_akhir=${state.tgl_akhir}&idlayanan=${state.idlayanan}&idkategori=${state.idkategori}&idstatus=${state.idstatus}&idpriority=${state.idpriority}&time=${state.time}`;
				break;
			case "listDashboard":
				API += `&tgl_awal=${state.tgl_awal}&tgl_akhir=${state.tgl_akhir} `;
				break;
			default:
				break;
		}
		return API;
	};

	const handleErrorStatus = async (res) => {
		switch (res.status) {
			case 403:
				window.location.replace("/403");
				break;
			case 404:
				window.location.replace("/404");
				break;
			case 500:
				window.location.replace("/500");
				break;
			default:
				break;
		}
		return res;
	};

	const getDataTable = async (props) => {
		const { url, pageSize, page, search, state, type } = props;

		let API = `${url}?limit=${pageSize}&page=${page + 1}&search=${
			search || ""
		}`;
		API = await handleGetService(API, state, type);
		const res = await fetch(API, reqOptions("GET"));
		await handleErrorStatus(res);
		const resJson = await res.json();
		return resJson;
	};

	const postData = async (url, body) => {
		const res = await fetch(`${url}`, reqOptions("POST", body));
		const resJson = await res.json();
		return resJson;
	};

	const postFormData = async (url, body) => {
		const res = await fetch(
			`${url}`,
			reqOptions("POST", body, true, "FORMDATA")
		);
		const resJson = await res.json();
		return resJson;
	};

	const putData = async (url, body) => {
		const res = await fetch(`${url}`, reqOptions("PUT", body));
		const resJson = await res.json();
		return resJson;
	};

	const delData = async (url, body) => {
		const res = await fetch(`${url}`, reqOptions("DELETE", body));
		const resJson = await res.json();
		return resJson;
	};

	const getOptionAll = async (url) => {
		const res = await fetch(`${url}`, reqOptions("GET"));
		const resJson = await res.json();
		return resJson;
	};

	return {
		getDataTable,
		postData,
		postFormData,
		putData,
		delData,
		getOptionAll,
	};
};

export default useAPI;
